import { cookieAxios } from "../../../../interceptors/cookieAxios";
import { errorToast } from "../../../../react-toastfiy/toast";

/**
 * Lead Dashboard analytics service. Mirrors lead.service.js (cookieAxios ->
 * the meratractor backend, returns response.data, errorToast on failure).
 * Endpoints live in meratractor/user/lead_dashboard_views.py.
 */
class LeadDashboardService {
  getDashboardStats = async (params) => {
    return cookieAxios({
      method: "get",
      url: `/user/lead-dashboard-stats`,
      params,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getFollowups = async (params) => {
    return cookieAxios({
      method: "get",
      url: `/user/lead-followups`,
      params,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
        errorToast(error?.message);
      });
  };

  getLeaderboard = async (params) => {
    return cookieAxios({
      method: "get",
      url: `/user/lead-leaderboard`,
      params,
    })
      .then((response) => response.data)
      .catch((error) => {
        // 403 for agent role is expected — surface other failures only
        if (error?.response?.status !== 403) {
          console.log(error);
          errorToast(error?.message);
        }
        return { success: false, agents: [] };
      });
  };

  // Per-agent activity: summary always; detail for one agent (?agent=) or all
  // agents (?detail=all, used by the Excel export).
  getLeadActivity = async (params) => {
    return cookieAxios({
      method: "get",
      url: `/user/lead-activity`,
      params,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
        const reason =
          error?.response?.data?.error || error?.message || "Failed to load";
        errorToast(reason);
        return { success: false, error: reason };
      });
  };
}

const leadDashboardService = new LeadDashboardService();
export default leadDashboardService;
